<template>
  <v-row justify="center">
    <v-col
      cols="12"
    >
      <v-card>
        <v-card-text>
          <div>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="campaign.name"
                  hint="Наименование Программы лояльности"
                  label="Наименование"
                  placeholder="Наименование Программы лояльности"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="campaign.description"
                  hint="Описание Программы лояльности"
                  label="Описание"
                  placeholder="Описание Программы лояльности"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="4">
                <v-switch
                  v-model="campaign.status"
                  :label="campaign.status ? 'Статус (Активная)' : 'Статус (Неактивная)'"
                />
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-divider inset />
        <v-card-actions class="d-flex flex-row">
          <v-row
            align-content="space-between"
            justify="space-around"
          >
            <v-btn
              v-if="campaignId===0"
              color="primary"
              outlined
              @click="back"
            >
              Назад
            </v-btn>

            <v-btn
              :disabled="newNameInvalid"
              color="primary"
              @click="campaign.campaignId > 0 ? save() : create()"
            >
              {{ campaign.campaignId > 0 ? "Сохранить" : "Создать" }}
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import WebApi from "../../shared/modules/web_api"
import { CampaignModel } from "@/views/loyalty/models/campaign.model"
import { localStock } from "@/views/loyalty/shared/classes/local_stock"
import { JustpayClient } from "@/views/loyalty/shared/services/justpay-client-service"
import { JustpayUser } from "@/views/loyalty/shared/services/justpay-user-service"
import { CampaignService } from "@/views/loyalty/shared/services/campaign-service"

export default {
  name: "CampaignEdit",
  props: {
    campaignId: {
      type: Number,
      default: 0
    },
    customerId: {
      type: String,
      default: ''
    },
    customerNumber: {
        type: String,
        default: ''
    }
  },
  data: () => ({
    name: "",
    description: "",
      campaignService: null,
    justpayClientService: null,
      justpayUserService: null,
    status: false,
    campaign: {},
    // customerId: "",
    webApi: null
  }),
  computed: {
    newNameInvalid () {
      return !this.campaign.name
    }
  },
    watch: {
        customerNumber (newVal, oldVal) {
            console.log(`customerNumber oldVal=${oldVal} newVal=${newVal}`)
            this.campaign.customerNumber = newVal
        }
    },
  beforeMount () {
    // console.clear()
    // const campaignId = +this.$route.params.campaign
    this.webApi = new WebApi(this.$store)
        .createSuccess("Программа лояльности создана!")
        .createError("Произошла ошибка при создании Программы лояльности!")
        .editSuccess("Программа лояльности сохранена!")
        .editError("Произошла ошибка при сохранении Программы лояльности!")
      this.campaignService = new CampaignService()
    // this.justpayClientService = new JustpayClient()
      this.justpayUserService = new JustpayUser()
  },
  mounted () {
    // this.campaign.customerId = this.$route.params.customer
    // this.campaign = this.$store.getters['campaign_store/getCampaign'].campaign
    this.campaign = localStock.getItem('campaign')
    this.campaign.customerId = this.$route.params.customer
    this.campaign.customerNumber = this.customerNumber //   await this.justpayClientService.getClientNumber(this.campaign.customerId)

    console.log("mounted this.campaign=", this.campaign)
  },
  methods: {
    async create () {
      console.log("creating....")
      console.log(this.campaign)
      const camp = { campaign: {}, participants: {} }
      const that = this
      const campaign_creating = Object.assign({}, this.campaign)
      delete campaign_creating.campaignId
      console.log('campaign_creating', campaign_creating)
      console.log(this.campaign)
      /// //////
      // this.axios
      //     .post(`${process.env.VUE_APP_JUSTPAY_URL}api/user/list`, {
      //       // .post("https://lk.justpay.pro/api/user/list", {
      //       page: 0,
      //       limit: 0
      //     })
      //     .then(response => {
      //       console.log(response.data.data)
      //       camp.campaign = campaign_creating
      //       const participants = response.data.data.map(m => m.id)
      //       console.log('participants', participants)
      //       camp.participants = participants
      //
      //       console.log('camp', camp)
      //       this.webApi
      //           .post(`${process.env.VUE_APP_LOYALTY_URL}api/campaign/`, camp)
      //           .then(function (data) {
      //             console.log(data.campaignId)
      //             // set to campaignId new value after creating Campaign object
      //             that.campaign.campaignId = data.campaignId
      //           })
      //     })
      // for participants - users logged direct to Justpay
      // they have to have property Number or something similar
      // while that code temporary is blocked
      //   const users = await this.justpayUserService.getUsers()
        camp.campaign = campaign_creating
        // const participants = users.data.map(m => m.id)
        const participants = ['']
            console.log('participants', participants)
        camp.participants = participants
        const campaign = await this.campaignService.createCampaign(camp)
        console.log('campaign', campaign)
        this.campaign.campaignId = campaign.campaignId

      this.back()
    },
    save () {
      console.log("saving...")
      this.webApi
          .patch(
              `${process.env.VUE_APP_LOYALTY_URL}api/campaign/` +
              this.campaign.campaignId,
              this.campaign
          )
          .then(function (response) {
            console.log(response)
          })
          .catch(function (error) {
            console.error("Error -> " + error)
          })
      this.back()
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<style scoped></style>
